import {DimensionValue, Dimensions, Platform, StyleSheet} from 'react-native';

let windowDim = Dimensions.get('window').width;

export const reloadStyles = () => {
  windowDim = Dimensions.get('window').width;
  const gs = StyleSheet.create({
    /* mobile */
    mobileContainerFluid: {
      padding: 8,
      overflow: 'visible',
    },
    /* WEB */
    containerFluid: {
      alignSelf: 'center',
      marginLeft: 'auto',
      marginRight: 'auto',
      paddingTop: 0,
      paddingBottom: 0,
      paddingHorizontal: 16,
      flex: 1,
      maxWidth: windowDim <= 1024 ? '100%' : 820,
      flexWrap: 'wrap',
    },
    formContain: {
      paddingTop: Platform.OS === 'web' ? 48 : 5,
      paddingBottom: Platform.OS === 'web' ? 48 : 16,
      paddingHorizontal: windowDim <= 786 ? 20 : 100,
    },
    row: {
      flex: 1,
      width: '100%',
      flexDirection: 'row',
      flexWrap: 'wrap',
      overflow: 'visible',
    },
    dHorizontal: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      alignContent: 'center',
      paddingVertical: 16,
      paddingHorizontal: 8,
      flexWrap: 'nowrap',
    },
    containerMenuItem: {
      height: 156,
      marginTop: 12,
      marginRight: 12,
      marginLeft: 12,
      marginBottom: 12,
      paddingRight: windowDim <= 400 ? 12 : 14,
      paddingLeft: windowDim <= 400 ? 12 : 14,
      paddingTop: windowDim <= 400 ? 12 : 14,
      paddingBottom: windowDim <= 400 ? 12 : 14,
      flexBasis:
        windowDim <= 725
          ? ('calc(50% - 24px)' as DimensionValue)
          : ('calc(25% - 24px)' as DimensionValue),
      minWidth:
        windowDim <= 400
          ? ('calc(100% - 24px)' as DimensionValue)
          : ('calc(25% - 24px)' as DimensionValue),
      backgroundColor: 'white',
      borderRadius: 16,
      alignItems: 'center',
      justifyContent: 'flex-start',
      flex: 1,
      shadowOffset: {width: 2, height: 6},
      shadowColor: '#000000',
      shadowOpacity: 0.06,
      shadowRadius: 16,
      elevation: 4,
    },
    containerMenuItemFullHome: {
      marginTop: 12,
      marginRight: 12,
      marginLeft: 12,
      marginBottom: 12,
      paddingLeft: windowDim <= 576 ? 0 : 0,
      paddingRight: windowDim <= 576 ? 0 : 0,
      paddingTop: windowDim <= 576 ? 0 : 0,
      paddingBottom: windowDim <= 576 ? 0 : 0,
      backgroundColor: 'rgba(255,255,255,0)',
      borderRadius: 16,
      borderColor: '#f2f5f6',
      alignItems: 'center',
      justifyContent: 'flex-start',
      flexDirection: 'row',
      flex: 2,
      flexBasis:
        windowDim <= 720
          ? ('calc(100% - 24px)' as DimensionValue)
          : ('calc(50% - 24px)' as DimensionValue),
      maxWidth:
        windowDim <= 1024
          ? ('calc(100% - 24px)' as DimensionValue)
          : ('calc(50% - 24px)' as DimensionValue),
      shadowOffset: {width: 2, height: 6},
      shadowColor: '#000000',
      shadowOpacity: 0.06,
      shadowRadius: 16,
      elevation: 4,
    },
    containerMenuItemFull: {
      marginTop: 12,
      marginRight: 12,
      marginLeft: 12,
      marginBottom: 12,
      paddingLeft: windowDim <= 576 ? 16 : 24,
      paddingRight: windowDim <= 576 ? 16 : 24,
      paddingTop: windowDim <= 576 ? 16 : 32,
      paddingBottom: windowDim <= 576 ? 16 : 32,
      borderRadius: 16,
      borderColor: '#f2f5f6',
      alignItems: 'center',
      justifyContent: 'flex-start',
      flexDirection: 'row',
      flex: 2,
      flexBasis:
        windowDim <= 720
          ? ('calc(100% - 24px)' as DimensionValue)
          : ('calc(50% - 24px)' as DimensionValue),
      maxWidth:
        windowDim <= 1024
          ? ('calc(100% - 24px)' as DimensionValue)
          : ('calc(50% - 24px)' as DimensionValue),
      shadowOffset: {width: 2, height: 6},
      shadowColor: '#000000',
      shadowOpacity: 0.06,
      shadowRadius: 16,
      elevation: 4,
    },
    MenuItemFont: {
      marginTop: 8,
      marginBottom: 8,
      fontSize: 16,
      lineHeight: 20,
      textAlign: 'center',
      justifyContent: 'center',
      fontWeight: '400',
    },
    MenuItemLogo: {
      marginTop: 8,
      width: 64,
      height: 64,
      resizeMode: 'contain',
      display: 'flex',
      minHeight: 60,
    },
    MenuIteAvatarContain: {
      width: 64,
      height: 64,
      borderRadius: 64,
      overflow: 'hidden',
    },
    MenuItemLogoFull: {
      width: 64,
      height: 64,
      borderRadius: 64,
      resizeMode: 'contain',
    },
    profilText: {
      marginLeft: windowDim <= 576 ? 16 : 24,
      marginTop: 8,
      marginBottom: 8,
      flex: 1,
    },

    /* ALL */
    titleSecondaryH2: {
      fontSize: 16,
      color: '#FFFFFF',
      fontWeight: 'bold',
      marginBottom: windowDim <= 720 ? 4 : 8,
    },
    titleSecondaryH2Accueil: {
      fontSize: windowDim <= 720 ? windowDim * 0.033 : 18,
      color: '#FFFFFF',
      fontWeight: 'bold',
      marginBottom: windowDim <= 720 ? 0 : 3,
    },
    titlePrimaryH2: {
      fontSize: windowDim <= 720 ? 18 : 16,
      lineHeight: 21,
      color: '#1D5C42',
      fontWeight: '700',
      marginTop: windowDim <= 720 ? 0 : 4,
      marginBottom: windowDim <= 720 ? 8 : 12,
    },
    paragraphe: {
      fontSize: windowDim <= 1024 ? 12 : 16,
      lineHeight: 18,
      fontWeight: '400',
      marginTop: windowDim <= 720 ? 4 : 8,
      marginBottom: windowDim <= 720 ? 12 : 16,
    },
    link: {
      color: '#58A618',
      fontSize: 12,
      fontWeight: 'bold',
      textDecorationLine: 'underline',
      textDecorationStyle: 'solid',
    },
    linkProfil: {
      color: '#FFFFFF',
      fontSize: windowDim <= 720 ? windowDim * 0.03 : 16,
      fontWeight: 'bold',
      textDecorationLine: 'underline',
      textDecorationStyle: 'solid',
    },
    linkProfilWeb: {
      color: '#FFFFFF',
      fontSize: 12,
      fontWeight: 'bold',
      textDecorationLine: 'underline',
      textDecorationStyle: 'solid',
    },
    colorLightPrimary: {
      color: '#9DB6AC',
    },
    imageIcon: {
      width: 24,
      height: 24,
      resizeMode: 'contain',
      marginVertical: 16,
      marginLeft: 24,
      marginRight: 8,
    },
    linearGradient: {
      flex: 1,
      paddingLeft: 15,
      paddingRight: 15,
      borderRadius: 5,
    },
    textDescription: {
      fontSize: windowDim <= 1024 ? 12 : 16,
      lineHeight: 18,
      fontWeight: '400',
      marginTop: windowDim <= 720 ? 4 : 8,
      marginBottom: windowDim <= 720 ? 12 : 16,
      color: '#A0CDA2',
    },
    textDescriptionAccueil: {
      fontSize: windowDim <= 720 ? windowDim * 0.03 : 16,
      lineHeight: 14,
      fontWeight: '400',
      marginTop: windowDim <= 720 ? 3 : 6,
      marginBottom: windowDim <= 720 ? 4 : 7,
      color: '#A0CDA2',
    },
    fullEcranWeb: {
      width: '100%',
    },
  });
  return gs;
};

export const globalStyle = reloadStyles();

export default globalStyle;
